import { render, staticRenderFns } from "./wilayah.vue?vue&type=template&id=42c4f3e2"
import script from "./wilayah.vue?vue&type=script&lang=js"
export * from "./wilayah.vue?vue&type=script&lang=js"
import style0 from "./wilayah.vue?vue&type=style&index=0&id=42c4f3e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports